<template>
  <div>
    <b-loading
        v-model="isLoading"
        :can-cancel="true"
        :is-full-page="true"
    ></b-loading>
    <div class="main-style-menu">
<!--      <transition name="fade" mode="out-in" v-if="selectedQueryProject === null && selectedQuerySite === null">
        <search-box-dtp-query ref="searchBoxQuery"
                              @onToggleSelectedProject="onToggleSelectedProject" @onClickedArea="onClickedProjectSearch"></search-box-dtp-query>
      </transition>-->
      <transition name="fade" mode="out-in" v-if="selectedQueryProject === null && selectedQuerySite === null">
        <search-box-per-site ref="searchBoxSite" @onToggleSelectedSite="onToggleSelectedSite" @onClickedArea="onClickedSiteSearch"></search-box-per-site>
      </transition>
      <div style="padding-top: 32px; padding-bottom: 24px;" v-if="selectedQueryProject === null && selectedQuerySite === null">
        <div class="columns ml-4 mr-4">
          <div class="column mr-1 ml-0 is-flex" style="height: 40px; width: 47vw; min-width: 47vw;">
          </div>
          <div class="column shadow mr-1 ml-0 is-flex has-background-grey-dark" style="height: 40px">
            <div class="is-size-7 has-text-white">ALL</div>
            <div class="is-size-5 has-text-weight-bold is-fullwidth ml-auto has-text-white" style="line-height: 1">{{getSum()}}</div>
          </div>
          <div class="column shadow mr-1 ml-1 is-flex has-background-danger" style="height: 40px">
            <div class="is-size-7 has-text-white">NEW</div>
            <div class="is-size-5 has-text-weight-bold is-fullwidth ml-auto has-text-white" style="line-height: 1">{{report !== null ? report.overallStatus.new : 0}}</div>
          </div>
          <div class="column shadow mr-1 ml-1 is-flex has-background-grey" style="height: 40px">
            <div class="is-size-7 has-text-white">RESPONDED</div>
            <div class="is-size-5 has-text-weight-bold is-fullwidth ml-auto has-text-white" style="line-height: 1">{{report !== null ? report.overallStatus.responded : 0}}</div>
          </div>
          <div class="column shadow mr-0 ml-1 is-flex has-background-primary" style="height: 40px">
            <div class="is-size-7 has-text-white">SUBMITTED</div>
            <div class="is-size-5 has-text-weight-bold is-fullwidth ml-auto has-text-white" style="line-height: 1">{{report !== null ? report.overallStatus.submitted : 0}}</div>
          </div>
        </div>
      </div>
<!--      <div v-if="selectedQueryProject" class="pb-6">
        <div>
          <div class="is-flex has-background-white title-box p-2">
            <div class="is-size-4 ml-5 mr-2 pt-1 pb-1 has-text-weight-bold">{{ selectedQueryProject.name }}
            </div>
            <b-tooltip class="ml-auto mt-auto mb-auto mr-2" label="Close project" :delay="1000" type="is-dark"
                       position="is-top">
              <b-button class="card-header-icon" aria-label="more options"
                        @click="closeProjectOverview">
                <b-icon icon="close"></b-icon>
              </b-button>
            </b-tooltip>
          </div>
          <div class="is-flex is-flex-direction-column p-5" style="padding-bottom: 200px !important;">
            <dtp-query-site-card v-for="item in dtpQueries" :site="item" :key="item.siteId"
                                 class="mb-1"></dtp-query-site-card>
          </div>
        </div>
      </div>-->
      <div v-if="selectedQuerySite" class="pb-6">
        <div>
          <div class="is-flex has-background-white title-box p-2">
            <div class="is-size-4 ml-5 mr-2 pt-1 pb-1 has-text-weight-bold">{{ selectedQuerySite.name }}
            </div>
            <b-tooltip class="ml-auto mt-auto mb-auto mr-2" label="Close site" :delay="1000" type="is-dark"
                       position="is-top">
              <b-button class="card-header-icon" aria-label="more options"
                        @click="closeSiteOverview">
                <b-icon icon="close"></b-icon>
              </b-button>
            </b-tooltip>
          </div>
          <div class="is-flex is-flex-direction-column p-5" style="padding-bottom: 200px !important;">
            <dtp-query-site-card v-for="item in dtpQueries" :site="item" :key="item.siteId"
                                 class="mb-1"></dtp-query-site-card>
          </div>
        </div>
      </div>
      <div v-else @click="onClickedOutside" style="height: 80vh"></div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import SearchBoxDtpQuery from "@/modules/dtp-query/components/search-box-dtp-query/search-box-dtp-query.vue";
import {nextTick} from "vue";
import DtpQuerySiteCard from "@/modules/dtp-query/components/dtp-query-site-card/dtp-query-site-card.vue";
import SearchBoxPerSite from "@/modules/dtp-query/components/search-box-per-site/serach-box-per-site.vue";

export default {
  name: "dtp-query-page",
  components: {SearchBoxPerSite, DtpQuerySiteCard},
  data() {
    return {
      isLoading: false,
      selectedDeviceId: null,
    }
  },
  async mounted() {
    this.isLoading = true;
    const response = await this.getDtpQueriesReport()
    await this.getUsers()
    if (response instanceof Error) {
      this.showToast(`Error: ${response.message}`, 'is-danger')
    }
    this.isLoading = false
  },
  methods: {
    ...mapActions({
      setSelectedQueryProject: 'dtpQueryModule/setSelectedQueryProject',
      setSelectedQuerySite: 'dtpQueryModule/setSelectedQuerySite',
      getDtpQueriesReport: 'dtpQueryModule/getDtpQueriesReport',
      getUsers: 'getUsers',
    }),
    async onToggleSelectedProject(project) {
      console.log('Selected project query - toggle', project)
      if (project === null) {
        await this.setSelectedQueryProject(null)
      } else {
        this.isLoading = true
        const response = await this.setSelectedQueryProject(project)
        if (response instanceof Error) {
          this.showToast(`Error: ${response.message}`, 'is-danger')
        }
        this.isLoading = false
      }
    },
    async onToggleSelectedSite(site) {
      console.log('Selected project query - toggle site', site)
      if (site === null) {
        await this.setSelectedQuerySite(null)
      } else {
        this.isLoading = true
        const response = await this.setSelectedQuerySite(site)
        if (response instanceof Error) {
          this.showToast(`Error: ${response.message}`, 'is-danger')
        }
        this.isLoading = false
      }
    },
    closeProjectOverview() {
      this.setSelectedQueryProject(null)
    },
    closeSiteOverview() {
      this.setSelectedQuerySite(null)
    },
    onClickedOutside() {
      console.log('On clicked outside')
      if (this.$refs.searchBoxQuery) {
        this.$refs.searchBoxQuery.onClickedOutside()
      }
      if(this.$refs.searchBoxSite){
        this.$refs.searchBoxSite.onClickedOutside()
      }
    },
    onClickedSiteSearch() {
      if (this.$refs.searchBoxQuery) {
        this.$refs.searchBoxQuery.onClickedOutside()
      }
    },
    onClickedProjectSearch() {
      if(this.$refs.searchBoxSite){
        this.$refs.searchBoxSite.onClickedOutside()
      }
    },
    onMapLoaded() {
      console.log('On map loaded')
    },
    getSum(){
      if(this.report){
        return this.report.overallStatus.new + this.report.overallStatus.submitted + this.report.overallStatus.responded
      }

      return 0
    },
    showToast(message, type) {
      this.$buefy.toast.open({
        message: message,
        duration: 3000,
        type: type
      })
    },
  },
  computed: {
    ...mapGetters({
      selectedQueryProject: 'dtpQueryModule/getSelectedQueryProject',
      selectedQuerySite: 'dtpQueryModule/getSelectedQuerySite',
      dtpQueries: 'dtpQueryModule/getDtpQueries',
      report: 'dtpQueryModule/getReport'
    }),
  }
}
</script>

<style scoped lang="scss">

.shadow {
  box-shadow: 0 0.125em 0.125em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02);
  background: white;
  border-radius: 8px;
}

</style>